import { cn, PaletteUtils } from '@shared/utils';
import { Button, Icon } from '@shared/widgets';
import CrossIcon from '@assets/icons/cross.svg';

interface IRemoveUserItemProps {
  className?: string;
  firstName: string;
  onRemove: () => void;
}

export const RemoveUserItem = (props: IRemoveUserItemProps) => {
  return (
    <div
      className={cn(
        'flex w-full items-center justify-between gap-2 rounded-sm p-3 pl-6',
        PaletteUtils.isInsigniaPalette && 'bg-ice dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'bg-ghost-white dark:bg-light/5',
        props.className,
      )}
    >
      <div className='shrink-0'>
        <div className='flex shrink items-center gap-3'>
          <div className='relative flex h-12 w-12 flex-none select-none items-center justify-center overflow-hidden rounded-full text-center'>
            <div
              className={cn(
                'relative z-10 flex h-full w-full items-center justify-center rounded-[inherit] bg-primary text-center text-xl font-medium',
                PaletteUtils.isInsigniaPalette && 'text-soft-black',
                PaletteUtils.isVcfcPalette && 'text-white',
              )}
            >
              {props.firstName.split('')[0]}
            </div>
          </div>
          <div className='py-1'>
            <div className='overflow-hidden text-ellipsis text-xl font-medium'>{props.firstName}</div>
          </div>
        </div>
      </div>
      <Button className='p-0' color='icon' onClick={props.onRemove}>
        <Icon icon={<CrossIcon width='24' height='24' />} color='red' />
      </Button>
    </div>
  );
};
